import { useQuery } from "@tanstack/react-query";
import type { ProjectStatsQueryDTO } from "@/modules/management/project/domain/repo/get-project-stats";
import type { ListProjectsQuery } from "@/modules/management/project/domain/types";
import { managementProjectApi } from "./client";

export function useProjectsQuery(query: ListProjectsQuery) {
  return useQuery({
    queryKey: ["management", "projects", "list", query],
    queryFn: () => managementProjectApi.list(query),
  });
}

export function useProjectStats(
  query: ProjectStatsQueryDTO,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["management", "projects", "stats", query],
    queryFn: () => managementProjectApi.getStats(query),
    enabled: options?.enabled ?? true,
  });
}

export function useProjectById(id: string | undefined) {
  return useQuery({
    queryKey: ["management", "projects", id],
    queryFn: () => {
      if (!id) throw new Error("Project id is required");
      return managementProjectApi.getById(id);
    },
    enabled: !!id,
  });
}

export function useProjectTasks(projectId: string | undefined) {
  return useQuery({
    queryKey: ["management", "projects", projectId, "tasks"],
    queryFn: () => {
      if (!projectId) throw new Error("Project id is required");
      return managementProjectApi.getTasks(projectId);
    },
    enabled: !!projectId,
  });
}

export function useProjectRisks(projectId: string | undefined) {
  return useQuery({
    queryKey: ["management", "projects", projectId, "risks"],
    queryFn: () => {
      if (!projectId) throw new Error("Project id is required");
      return managementProjectApi.getRisks(projectId);
    },
    enabled: !!projectId,
  });
}
